<template>
  <div class="api-integration-page">

    <section class="content">
      <h2 style="margin-top: 10px; margin-bottom: 20px;">Integrate Vedic Astrology with Your Application</h2>
      <p style="text-align: justify;">
        The <strong>Vedic Astrology API</strong> from <strong>vedicastrochart.com</strong>
        enables developers to seamlessly integrate high-accuracy and reliable Vedic Astrology calculations into websites, mobile apps, platform, or research tool.
      </p>

      <div class="features">
        <h2 style="text-align: left; margin-top: 20px; margin-bottom: 20px;">Key Features</h2>
        <ul>
          <li>Planetary Positions with Sign, Nakshatra, Degrees</li>
          <li>20 Divisional / Varga Chart calculations</li>
          <li>House Cusps Calculations</li>
          <li>4 Levels of Vimsottrai periods for planets & house cusps</li>
          <li>Ascendant / Lagna calculation for given date, time and location</li>
          <li>Panchanga: Tithi, Yoga, Karana, Nakshatra</li>
          <li>Jamakkol Prasanam calculations with inner & outer planets</li>
          <li>K.P. Horary Chart calculations</li>
          <li>Sunrise, Sunset, and Hora Calculations</li>
          <li>Sub-planet Maandi calculation with 5 distinctive methods</li>
          <li>City search API ideal for autocomplete dropdowns</li>
          <li>Simple REST API with API Key Authentication</li>
          <li>Free Trial Access to explore the available APIs and test integration</li>
          <li>Buy API integration packs and use them at your own pace</li>
        </ul>
      </div>

      <div class="cta">
        <a
          class="btn primary"
          href="https://api.vedicastrochart.com/"
          target="_blank"
        >
          API Integration Portal
        </a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ApiIntegration",
};
</script>

<style scoped>
.api-integration-page {
  background-color: #FBFBFF;
  color: #2c3e50;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  padding: 0 20px;
}

.content {
  max-width: 900px;
  margin: 40px auto;
  background-color: #EDF6F9;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.content h2 {
  color: #1a2e2b;
  margin-bottom: 10px;
}

.content p {
  font-size: 16px;
  line-height: 1.6;
}

.features ul {
  padding-left: 20px;
  list-style: disc;
  margin-top: 15px;
  text-align: left;
}

.features li {
  margin-bottom: 10px;
  font-size: 15px;
}

.cta {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.btn {
  text-decoration: none;
  padding: 14px 24px;
  font-weight: bold;
  border-radius: 6px;
  text-align: center;
  width: 100%;
  max-width: 300px;
}

.btn.primary {
  background-color: #087F8C;
  color: white;
}

.btn.secondary {
  background-color: transparent;
  color: #344e41;
  border: 2px solid #344e41;
}

.btn.secondary:hover {
  background-color: #d3e4cd;
}

@media (min-width: 600px) {
  .btn {
    width: auto;
  }
}
</style>
